import React, { useEffect, useState } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_my_company_member_file_folder_wizard/EditMyCompanyMemberFileFolderForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import * as _ from 'lodash';
import Input from '../../components/Input';
import { connect } from 'react-redux';
import { listCompanyFolders } from '../../redux/actions/table/company_folders';

const EditMyCompanyMemberFileFolderForm = ({ handleSubmit, submitting }) => {
  const [possibleFolders, setPossibleFolders] = useState([]);

  useEffect(() => {
    listCompanyFolders().then(({ response }) => {
      setPossibleFolders(response.data || []);
    });
  }, []);

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='folder_id'
          component={Select}
          searchable
          label={__(
            'my_company_members.flyout.edit-my-company-member-file-folder'
          )}
          options={possibleFolders?.map((folder) => ({
            label: folder.name,
            value: folder.id,
          }))}
        />
        <Field
          name='description'
          component={Input}
          label={__(
            'my_company_members.flyout.edit-my-company-member-file-description'
          )}
          placeholder={__(
            'my_company_members.flyout.edit-my-company-member-file-add-description'
          )}
        />
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('my_company_members', {
              edit_my_company_member_file_folder_wizard: undefined,
            })
          }
        />
        <Button
          lightBlue
          medium
          right
          submit
          middleText={__('button.edit')}
          spinning={submitting}
        />
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    store: _.get(state.table, 'my_company_members'),
  };
};

export default withRouter(
  reduxForm({
    form: 'edit_my_company_member_file_folder_wizard.edit_my_company_member_file_folder',
  })(
    connect(
      mapStateToProps,
      null
    )(
      subscribe(Localization, 'localization')(EditMyCompanyMemberFileFolderForm)
    )
  )
);
